import React from 'react';
import { PoundSterling, Receipt, ShieldCheck, Landmark, TrendingUp } from 'lucide-react';

const SUMMARY_ITEMS = [
  { id: 'sum-gross', label: 'Total Gross Pay', value: '£38,472.00', sub: '47 workers', icon: PoundSterling, color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'sum-paye', label: 'Total PAYE Tax', value: '£7,340.20', sub: 'Avg. £156.17 / worker', icon: Receipt, color: 'text-accent', bg: 'bg-accent/10' },
  { id: 'sum-ee-ni', label: 'Employee NI', value: '£2,891.40', sub: 'Cat. A / B / C mix', icon: ShieldCheck, color: 'text-info', bg: 'bg-info/10' },
  { id: 'sum-er-ni', label: 'Employer NI', value: '£2,327.10', sub: '13.8% above sec. threshold', icon: ShieldCheck, color: 'text-warning', bg: 'bg-warning/10' },
  { id: 'sum-pension', label: 'Pension (NEST)', value: '£1,154.16', sub: 'Ee 5% + Er 3%', icon: Landmark, color: 'text-success', bg: 'bg-success/10' },
  { id: 'sum-net', label: 'Total Net Pay', value: '£24,759.14', sub: 'To be paid 09 May', icon: TrendingUp, color: 'text-foreground', bg: 'bg-secondary' },
];

export default function PayrollSummaryCards() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
      {SUMMARY_ITEMS?.map((item) => (
        <div key={item?.id} className="bg-card border border-border rounded-xl p-4">
          <div className="flex items-center gap-2 mb-2">
            <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${item?.bg}`}>
              <item.icon size={14} className={item?.color} />
            </div>
            <p className="text-[11px] font-500 uppercase tracking-[0.05em] text-muted-foreground">{item?.label}</p>
          </div>
          <p className="text-xl font-700 font-mono tabular-nums text-foreground">{item?.value}</p>
          <p className="text-[11px] text-muted-foreground mt-0.5">{item?.sub}</p>
        </div>
      ))}
    </div>
  );
}